import React, { useCallback } from "react";
import { RulesEditorActivatableSection } from "./rules-editor-activatable-section";
import RulesEditorAlertSectionOpen from "./rules-editor-alert-section-open";
import { RulesEditorEventErrorState } from "./state/input/rules-editor-error-state";
import {
	RULES_EVENT_INPUT_STATE_DEFAULT,
	RulesEventInputState,
} from "./state/input/rules-event-input-state";

export interface RulesEditorAlertSectionProps {
	className?: string;
	title: string;
	settings: RulesEventInputState | null;
	onChangeSettings: (settings: RulesEventInputState | null) => void;
	error: RulesEditorEventErrorState;
}

export default function RulesEditorAlertSection(
	props: RulesEditorAlertSectionProps,
) {
	const onChangeSettings = props.onChangeSettings;

	const openSettings = useCallback(() => {
		onChangeSettings(RULES_EVENT_INPUT_STATE_DEFAULT);
	}, [onChangeSettings]);

	const closeSettings = useCallback(() => {
		onChangeSettings(null);
	}, [onChangeSettings]);

	if (props.settings === null) {
		return (
			<RulesEditorActivatableSection
				className={props.className}
				title={props.title}
				onActivate={openSettings}
			/>
		);
	} else {
		return (
			<RulesEditorAlertSectionOpen
				className={props.className}
				title={props.title}
				onClose={closeSettings}
				settings={props.settings}
				onChangeSettings={props.onChangeSettings}
				error={props.error}
			/>
		);
	}
}
